import React from "react";
import { Typography, Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { FruitifyContainer } from "../../../shared-components/Containers";
import { Add } from "@mui/icons-material";
import { FruitifyAssignmentSearch } from "../components/FruitifyAssignmentSearch";
import { withPageTracking } from "../../../services/postHog";

const AssignmentOverview = () => {
  const navigate = useNavigate();

  return (
    <FruitifyContainer>
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        gap={2}
        mb={2}
      >
        <Typography variant="h3" fontWeight="bold">
          Assignments
        </Typography>
        <Box display="flex" flexWrap="wrap" gap={2}>
          <Button variant="outlined" onClick={() => navigate("groups")}>
            Assignment Groups
          </Button>
          <Button
            variant="contained"
            endIcon={<Add />}
            onClick={() => navigate("create")}
          >
            Create Assignment
          </Button>
        </Box>
      </Box>
      <FruitifyAssignmentSearch excludeTitle />
    </FruitifyContainer>
  );
};

export default withPageTracking(AssignmentOverview, {
  feature: "assignments-overview",
});
